import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getPoByDevorderSupplier = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.GET_PO_BY_DEVORDER_SUPPLIER}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getFilteredPOs = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.GET_FILTERED_POS}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBulkFilteredPOs = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_PURCHASE_ORDER.BULK_FILTERED}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const orderSubmitDownload = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.ORDER_SUBMIT_DOWNLOAD}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Asks the server to build a submit-download, which it accepts and answers immediately.
 *
 * The older endpoint renders every module before replying, so the browser holds the connection
 * for the whole job. This one returns a request id; the file arrives over `submit-download-ready`.
 */
export const createSubmitDownloadRequest = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.SUBMIT_DOWNLOAD_REQUESTS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Reads where a submit-download got to, for a tab that missed the socket event.
 */
export const getSubmitDownloadRequest = async (requestId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.SUBMIT_DOWNLOAD_REQUESTS}/${requestId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const requestSampleMultiProducts = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.REQUEST_SAMPLE_MULTI_PRODUCTS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMeasurementDocuments = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GET_OHTER_DOCUMENT}/${data.id}`, { params: { ...data.obj } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getPoDocuments = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.GET_PO_DOCUMENTS}/${data.id}`, { params: { ...data.obj } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getBOMSUDocuments = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.GET_BOM_SUPPORTING_DOCUMENTS}/${data.id}`, { params: { ...data.obj } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const sendSupplierEmail = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.SEND_SUPPLIER_EMAIL}/${data?.devOrderId}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSubmitDownloadLog = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.ORDER_SUBMIT_DOWNLOAD}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getDownloadLog = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.ORDER_DOWNLOAD_LOG}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const activeInactiveSubmitLog = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.ACTIVE_INACTIVE_SUBMIT_LOG}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadFiles = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.DOWNLOAD_FILES}?devOrderId=${data.devOrderId}&email=${data.email}`, { ...data.obj });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSubmitLog = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.DOWNLOAD_FILES_URL_MAIN}?logId=${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteDownloadLog = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.ORDER_DOWNLOAD_LOG}?logId=${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadLogFiles = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.DOWNLOAD_LOG}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getsupplierUser = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.SUPPLIER_USER}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const requestForDownload = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.DOWNLOAD_FILES_URL_MAIN}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const retriveSubmitLog = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.DOWNLOAD_FILES_URL_MAIN}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadFromLinkLogZip = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.DOWNLOAD_FILES_URL_MAIN}?email=${data.email}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const multidownloadFromLinkLogZip = async (data, timeZone) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD_LOGS}`, { data, timeZone });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const multipleDownload = async (data, timeZone) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.MULTI_DOWNLOAD_LOGS}`, { data, timeZone });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMultiSubmitDownloadLogs = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD_LOGS}?reqId=${data?.reqId}&email=${data?.email}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMultiSubmitLogs = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD_LOGS}`, {
      data: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMultiDownloadLogs = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.MULTI_DOWNLOAD_LOGS}?reqId=${data?.reqId}&email=${data?.email}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMultiDownloadLogs = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.MULTI_DOWNLOAD_LOGS}`, {
      data: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadByUpdate = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUBMIT_DOWNLOAD.DOWNLOAD_BY_UPDATE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
